import { registerCascades } from "tsi-common-react/src/apps/retail/cascades";

import { store } from "../../store";

// Register store cascades
registerCascades(store, {
    has_slot_stearns_foster: "Y",
    distance: 50,
});
